'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleMap = exports.SimpleMap = function () {
    function SimpleMap() {
        _classCallCheck(this, SimpleMap);

        this.keys = [];
        this.values = [];
    }

    SimpleMap.prototype.get = function get(key) {
        var index = this.keys.indexOf(key);

        return this.values[index];
    };

    SimpleMap.prototype.set = function set(key, value) {
        this.keys.push(key);
        this.values.push(value);

        return value;
    };

    _createClass(SimpleMap, [{
        key: 'size',
        get: function get() {
            return this.keys.length;
        }
    }]);

    return SimpleMap;
}();

var exportedMap = typeof Map === 'undefined' ? SimpleMap : Map;

exports.default = exportedMap;


//////////////////
// WEBPACK FOOTER
// ../~/react-css-modules/dist/simple-map.js
// module id = 859
// module chunks = 0